import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimuladorNumericInput from "./SimuladorNumericInput";
import { truncar } from "../../Helpers/Truncar";

export const SimuladorIncentivoOR = ({ rango = null, setTotal = null }) => {

  const [state, setState] = useState({
    meta: 0,
    real: 0,
    cumplimiento: 0,
    porcentaje: 0,
    incentivo: 0,
  });
  const handleChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
  };
  useEffect(() => {
    if (Number(state.meta) !== 0 && Number(state.real) !== 0) {
      const cumplimiento = truncar((Number(state.real) / Number(state.meta)) * 100);
      let porcentaje = 0;
      let incentivo = 0;
      
      if (rango !== null) {
        rango.forEach((index) => {
          if (index.minimo <= cumplimiento && index.maximo >= cumplimiento) {
            porcentaje = index.porcentaje;
            incentivo = Number(state.real) * index.porcentaje;
          }
        });


        const newState = {
          ...state,
          cumplimiento,
          porcentaje: porcentaje * 100,
          incentivo,
        };

        setState(newState);
        if (setTotal) setTotal(incentivo);
      } else {
        const resetState = {
          ...state,
          cumplimiento: 0,
          porcentaje: 0,
          incentivo: 0,
        };
        setState(resetState);
        if (setTotal) setTotal(0);
      }
    }
  }, [state.meta, state.real, rango]);


  return (
    <div className="simulador-incentivo-vendedor-input">
      <div className="input-container-duo">
        <div className="input-section">
          <div className="input-title-label">Objetivo de venta</div>
          <SimuladorNumericInput
            name="meta"
            label=""
            value={state.meta}
            disabled={false}
            onChange={handleChange}
          />
        </div>
        <div className="input-section">
          <div className="input-title-label">Venta real</div>
          <SimuladorNumericInput
            name="real"
            label=""
            value={state.real}
            disabled={false}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="input-container-duo">
        <div className="input-section">
          <div className="input-title-label">Cumplimiento de venta</div>
          <SimuladorNumericInput
            name="cumplimiento"
            label=""
            value={state.cumplimiento}
            disabled={true}
            icono="porcentaje"
            align="centro"
          />
        </div>
        <div className="input-section">
          <div className="input-title-label">% incentivo a ganar</div>
          <SimuladorNumericInput
            name="porcentaje"
            label=""
            value={state.porcentaje}
            disabled={true}
            icono="porcentaje"
            align="centro"
          />
        </div>
      </div>

      <div className="input-container-one">
        <div className="input-section">
          <div className="input-title-label-incentive">Tu incentivo es de:</div>
          <SimuladorNumericInput
            name="incentivo"
            label=""
            value={state.incentivo}
            disabled={true}
            icono="pesos"
            inputTotal="si"
          />
        </div>
      </div>
    </div >
  );
};
